<script setup lang="ts">
import ApplicationBase from '../ApplicationBase.vue'
import Umsaekjandi from '../Shared/Umsaekjandi.vue'
import Step2 from './Steps/Step2.vue'
import Step3 from './Steps/Step3.vue'
import Step4 from './Steps/Step4.vue'
import Undirritun from '../Shared/Undirritun.vue'

import ApplicationSereignBegin from './Steps/ApplicationSereignBegin.vue'


const steps = [
  { comp: ApplicationSereignBegin,  titleKey: '' },
  { comp: Umsaekjandi,  titleKey: 'umsokn_umsaekjandi_header' },
  { comp: Step2,        titleKey: 'sereignar_umsokn_step2_header1_new' },
  { comp: Step3,        titleKey: 'sereignar_umsokn_step3_header' },
  { comp: Step4,        titleKey: 'sereignar_umsokn_step4_header' },
  { comp: Undirritun,   titleKey: 'undirritun_umsokn_header1' },
]

</script>

<template>
  <ApplicationBase :app-id="2" update-key="sereignumsokn" :steps="steps" />
</template>
